import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

const department = dictionary.extend({
  description: z.string().max(250).optional(),
});

export const readDepartment = department.readonly();
export const writeDepartment = department.omit({ id: true });
